module.exports = __webpack_public_path__ + "static/media/SymbolFetchingDoc.8b7f29fa.svg";